const ENTERPRISE = 'Enterprise';
const COMMUNITY = 'Community';

export { ENTERPRISE, COMMUNITY };



// WEBPACK FOOTER //
// ./src/constants/server-version.js